// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + "vendor.html5-qrcode" + "." + "cac49939af198ccb17ee" + ".20261101010502.js";
};